// LF-918: which link targets the sidebar will render as links.
//
// The server (Guidebook::AnswerLinks) already reduces every link in an answer
// to a vetted one — a guidebook page, a guidebook PDF, or a URL the guidebook
// itself links to — and escapes anything else. This is the backstop: if some
// other target ever got through, it renders as text.
const ALLOWED = [/^\/guidebook\//, /^https?:\/\//, /^mailto:/]

export const safeUrl = (url: string): string =>
  ALLOWED.some((pattern) => pattern.test(url)) ? url : ''

export const opensInNewTab = (url: string): boolean =>
  !url.startsWith('mailto:')
